// 打点统计
import store from "@/store";
import api from "@/api/api";

// 防止同一事件被多处重复触发
const firedEvents = new Set();
function shouldFire(eventName, id) {
  const key = `${eventName}_${id || ""}`;
  if (firedEvents.has(key)) return false;
  firedEvents.add(key);
  return true;
}
export const trace = {
  pageLoaded(id) {
    const channel = window.location.pathname;
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("PageLoaded", {}, { event_id: `PageLoaded_${id}` });
      // trace.postEventTrack(id, "PageLoaded");
    }
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "PageLoaded",
        {},
        { eventID: `PageLoaded_${id}` }
      );
      // trace.postSubmitEvent(id, "PageLoaded");
    }
    window.gtag("event", "PageLoaded", {
      transaction_id: `PageLoaded_${id}`,
    });
  },
  viewContent(id, type_id) {
    const channel = window.location.pathname;
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        `ViewContent_${type_id}`,
        {
          content_id: type_id,
        },
        { event_id: `ViewContent_${type_id}_${id}` }
      );
      // trace.postEventTrack(id, `ViewContent_${type_id}`);
    }
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "track",
        `ViewContent_${type_id}`,
        {
          content_ids: [type_id],
        },
        { eventID: `ViewContent_${type_id}_${id}` }
      );
      // trace.postSubmitEvent(id, `ViewContent_${type_id}`);
    }
    window.gtag("event", `ViewContent_${type_id}`, {
      transaction_id: `ViewContent_${type_id}_${id}`,
      content_id: type_id,
    });
    store.commit("setContent", {
      key: "viewContent",
      data: {
        type_id: type_id,
      },
    });
  },
  clickSendCodeBtn(id) {
    if (!shouldFire("ClickSendCodeBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickSendCodeBtn",
        {},
        { eventID: `ClickSendCodeBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickSendCodeBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickSendCodeBtn",
        {},
        { event_id: `ClickSendCodeBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickSendCodeBtn");
    }
    window.gtag("event", "ClickSendCodeBtn", {
      transaction_id: `ClickSendCodeBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickSendCodeBtn",
      data: true,
    });
  },
  clickBackBtn(id) {
    if (!shouldFire("ClickBackBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickBackBtn",
        {},
        { eventID: `ClickBackBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickBackBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickBackBtn",
        {},
        { event_id: `ClickBackBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickBackBtn");
    }
    window.gtag("event", "ClickBackBtn", {
      transaction_id: `ClickBackBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickBackBtn",
      data: true,
    });
  },
  clickForgotBtn(id) {
    if (!shouldFire("ClickForgotBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickForgotBtn",
        {},
        { eventID: `ClickForgotBtn_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickForgotBtn",
        {},
        { event_id: `ClickForgotBtn_${id}` }
      );
    }
    window.gtag("event", "ClickForgotBtn", {
      transaction_id: `ClickForgotBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickForgotBtn",
      data: true,
    });
  },
  clickShowLoginBtn(id) {
    if (!shouldFire("ClickShowLoginBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickShowLoginBtn",
        {},
        { eventID: `ClickShowLoginBtn_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickShowLoginBtn",
        {},
        { event_id: `ClickShowLoginBtn_${id}` }
      );
    }
    window.gtag("event", "ClickShowLoginBtn", {
      transaction_id: `ClickShowLoginBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickShowLoginBtn",
      data: true,
    });
  },
  clickCommunityBtn(id) {
    if (!shouldFire("ClickCommunityBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickCommunityBtn",
        {},
        { eventID: `ClickCommunityBtn_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickCommunityBtn",
        {},
        { event_id: `ClickCommunityBtn_${id}` }
      );
    }
    window.gtag("event", "ClickCommunityBtn", {
      transaction_id: `ClickCommunityBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickCommunityBtn",
      data: true,
    });
  },
  clickInfoBtn(id) {
    if (!shouldFire("ClickInfoBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickInfoBtn",
        {},
        { eventID: `ClickInfoBtn_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickInfoBtn",
        {},
        { event_id: `ClickInfoBtn_${id}` }
      );
    }
    window.gtag("event", "ClickInfoBtn", {
      transaction_id: `ClickInfoBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickInfoBtn",
      data: true,
    });
  },
  clickFacebookBtn(id) {
    if (!shouldFire("ClickFacebookBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickFacebookBtn",
        {},
        { eventID: `ClickFacebookBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickFacebookBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickFacebookBtn",
        {},
        { event_id: `ClickFacebookBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickFacebookBtn");
    }
    window.gtag("event", "ClickFacebookBtn", {
      transaction_id: `ClickFacebookBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickFacebookBtn",
      data: true,
    });
  },
  clickDiscordBtn(id) {
    if (!shouldFire("ClickDiscordBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickDiscordBtn",
        {},
        { eventID: `ClickDiscordBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickDiscordBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickDiscordBtn",
        {},
        { event_id: `ClickDiscordBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickDiscordBtn");
    }
    window.gtag("event", "ClickDiscordBtn", {
      transaction_id: `ClickDiscordBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickDiscordBtn",
      data: true,
    });
  },
  clickTwitterBtn(id) {
    if (!shouldFire("ClickTwitterBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickTwitterBtn",
        {},
        { eventID: `ClickTwitterBtn_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickTwitterBtn",
        {},
        { event_id: `ClickTwitterBtn_${id}` }
      );
    }
    window.gtag("event", "ClickTwitterBtn", {
      transaction_id: `ClickTwitterBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickTwitterBtn",
      data: true,
    });
  },
  clickGoogleBtn(id) {
    if (!shouldFire("ClickGoogleBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickGoogleBtn",
        {},
        { eventID: `ClickGoogleBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickGoogleBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickGoogleBtn",
        {},
        { event_id: `ClickGoogleBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickGoogleBtn");
    }
    window.gtag("event", "ClickGoogleBtn", {
      transaction_id: `ClickGoogleBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickGoogleBtn",
      data: true,
    });
  },
  clickAppleBtn(id) {
    if (!shouldFire("ClickAppleBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickAppleBtn",
        {},
        { eventID: `ClickAppleBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickAppleBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickAppleBtn",
        {},
        { event_id: `ClickAppleBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickAppleBtn");
    }
    window.gtag("event", "ClickAppleBtn", {
      transaction_id: `ClickAppleBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickAppleBtn",
      data: true,
    });
  },
  clickGalleryBtn(id) {
    if (!shouldFire("ClickGalleryBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickGalleryBtn",
        {},
        { eventID: `ClickGalleryBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickGalleryBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickGalleryBtn",
        {},
        { event_id: `ClickGalleryBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickGalleryBtn");
    }
    window.gtag("event", "ClickGalleryBtn", {
      transaction_id: `ClickGalleryBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickGalleryBtn",
      data: true,
    });
  },
  clickGameFeaturesBtn(id) {
    if (!shouldFire("ClickGameFeaturesBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickGameFeaturesBtn",
        {},
        { eventID: `ClickGameFeaturesBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickGameFeaturesBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickGameFeaturesBtn",
        {},
        { event_id: `ClickGameFeaturesBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickGameFeaturesBtn");
    }
    window.gtag("event", "ClickGameFeaturesBtn", {
      transaction_id: `ClickGameFeaturesBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickGameFeaturesBtn",
      data: true,
    });
  },
  clickReserveNowBtn(id) {
    if (!shouldFire("ClickReserveNowBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickReserveNowBtn",
        {},
        { eventID: `ClickReserveNowBtn_${id}` }
      );
      // trace.postSubmitEvent(id, "ClickReserveNowBtn");
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickReserveNowBtn",
        {},
        { event_id: `ClickReserveNowBtn_${id}` }
      );
      // trace.postEventTrack(id, "ClickReserveNowBtn");
    }
    window.gtag("event", "ClickReserveNowBtn", {
      transaction_id: `ClickReserveNowBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickReserveNowBtn",
      data: true,
    });
  },
  clickComingSoonButton(id, index) {
    if (!shouldFire(`ClickComingSoonButton${index}`, id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        `ClickComingSoonButton${index}`,
        {},
        { eventID: `ClickComingSoonButton${index}_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        `ClickComingSoonButton${index}`,
        {},
        { event_id: `ClickComingSoonButton${index}_${id}` }
      );
    }
    window.gtag("event", `ClickComingSoonButton${index}`, {
      transaction_id: `ClickComingSoonButton${index}_${id}`,
    });
    store.commit("setContent", {
      key: `clickComingSoonButton${index}`,
      data: true,
    });
  },
  clickAcceptPromotionButton(id) {
    if (!shouldFire("ClickAcceptPromotionButton", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickAcceptPromotionButton",
        {},
        { eventID: `ClickAcceptPromotionButton_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickAcceptPromotionButton",
        {},
        { event_id: `ClickAcceptPromotionButton_${id}` }
      );
    }
    window.gtag("event", "ClickAcceptPromotionButton", {
      transaction_id: `ClickAcceptPromotionButton_${id}`,
    });
    store.commit("setContent", {
      key: "clickAcceptPromotionButton",
      data: true,
    });
  },
  clickSpinBtn(id) {
    if (!shouldFire("ClickSpinBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickSpinBtn",
        {},
        { eventID: `ClickSpinBtn_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickSpinBtn",
        {},
        { event_id: `ClickSpinBtn_${id}` }
      );
    }
    window.gtag("event", "ClickSpinBtn", {
      transaction_id: `ClickSpinBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickSpinBtn",
      data: true,
    });
  },
  clickShareTwitterBtn(id) {
    if (!shouldFire("ClickShareTwitterBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickShareTwitterBtn",
        {},
        { eventID: `ClickShareTwitterBtn_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickShareTwitterBtn",
        {},
        { event_id: `ClickShareTwitterBtn_${id}` }
      );
    }
    window.gtag("event", "ClickShareTwitterBtn", {
      transaction_id: `ClickShareTwitterBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickShareTwitterBtn",
      data: true,
    });
  },
  clickShareFacebookBtn(id) {
    if (!shouldFire("ClickShareFacebookBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "trackCustom",
        "ClickShareFacebookBtn",
        {},
        { eventID: `ClickShareFacebookBtn_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track(
        "ClickShareFacebookBtn",
        {},
        { event_id: `ClickShareFacebookBtn_${id}` }
      );
    }
    window.gtag("event", "ClickShareFacebookBtn", {
      transaction_id: `ClickShareFacebookBtn_${id}`,
    });
    store.commit("setContent", {
      key: "clickShareFacebookBtn",
      data: true,
    });
  },
  LoginErrorPixie(id) {
    if (!shouldFire("LoginErrorPixie", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "LoginErrorPixie", {}, { eventID: `LoginErrorPixie_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("LoginErrorPixie", {}, { event_id: `LoginErrorPixie_${id}` });
    }
    window.gtag("event", "LoginErrorPixie", {
      transaction_id: `LoginErrorPixie_${id}`,
    });
  },
  PreRegistrationError(id) {
    if (!shouldFire("PreRegistrationError", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "PreRegistrationError", {}, { eventID: `PreRegistrationError_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("PreRegistrationError", {}, { event_id: `PreRegistrationError_${id}` });
    }
    window.gtag("event", "PreRegistrationError", {
      transaction_id: `PreRegistrationError_${id}`,
    });
  },
  clickStoreApp(id) {
    if (!shouldFire("ClickStoreApp", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickStoreApp", {}, { eventID: `ClickStoreApp_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickStoreApp", {}, { event_id: `ClickStoreApp_${id}` });
    }
    window.gtag("event", "ClickStoreApp", {
      transaction_id: `ClickStoreApp_${id}`,
    });
  },
  clickStoreGoogle(id) {
    if (!shouldFire("ClickStoreGoogle", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickStoreGoogle", {}, { eventID: `ClickStoreGoogle_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickStoreGoogle", {}, { event_id: `ClickStoreGoogle_${id}` });
    }
    window.gtag("event", "ClickStoreGoogle", {
      transaction_id: `ClickStoreGoogle_${id}`,
    });
  },
  clickShowPreRegistrationBtn(id) {
    if (!shouldFire("ClickShowPreRegistrationBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickShowPreRegistrationBtn", {}, { eventID: `ClickShowPreRegistrationBtn_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickShowPreRegistrationBtn", {}, { event_id: `ClickShowPreRegistrationBtn_${id}` });
    }
    window.gtag("event", "ClickShowPreRegistrationBtn", {
      transaction_id: `ClickShowPreRegistrationBtn_${id}`,
    });
  },
  clickBookingEntrance(id) {
    if (!shouldFire("ClickBookingEntrance", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickBookingEntrance", {}, { eventID: `ClickBookingEntrance_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickBookingEntrance", {}, { event_id: `ClickBookingEntrance_${id}` });
    }
    window.gtag("event", "ClickBookingEntrance", {
      transaction_id: `ClickBookingEntrance_${id}`,
    });
  },
  clickDownloadBtn(id) {
    if (!shouldFire("ClickDownloadBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickDownloadBtn", {}, { eventID: `ClickDownloadBtn_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickDownloadBtn", {}, { event_id: `ClickDownloadBtn_${id}` });
    }
    window.gtag("event", "ClickDownloadBtn", {
      transaction_id: `ClickDownloadBtn_${id}`,
    });
  },
  clickSpinSuccess(id) {
    if (!shouldFire("ClickSpinSuccess", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickSpinSuccess", {}, { eventID: `ClickSpinSuccess_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickSpinSuccess", {}, { event_id: `ClickSpinSuccess_${id}` });
    }
    window.gtag("event", "ClickSpinSuccess", {
      transaction_id: `ClickSpinSuccess_${id}`,
    });
  },
  clickSpinFailed(id) {
    if (!shouldFire("ClickSpinFailed", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickSpinFailed", {}, { eventID: `ClickSpinFailed_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickSpinFailed", {}, { event_id: `ClickSpinFailed_${id}` });
    }
    window.gtag("event", "ClickSpinFailed", {
      transaction_id: `ClickSpinFailed_${id}`,
    });
  },
  clickShareBtn(id) {
    if (!shouldFire("ClickShareBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickShareBtn", {}, { eventID: `ClickShareBtn_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickShareBtn", {}, { event_id: `ClickShareBtn_${id}` });
    }
    window.gtag("event", "ClickShareBtn", {
      transaction_id: `ClickShareBtn_${id}`,
    });
  },
  clickGoBtn(id) {
    if (!shouldFire("ClickGoBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickGoBtn", {}, { eventID: `ClickGoBtn_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickGoBtn", {}, { event_id: `ClickGoBtn_${id}` });
    }
    window.gtag("event", "ClickGoBtn", {
      transaction_id: `ClickGoBtn_${id}`,
    });
  },
  clickHeaderBtn(id) {
    if (!shouldFire("ClickHeaderBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickHeaderBtn", {}, { eventID: `ClickHeaderBtn_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickHeaderBtn", {}, { event_id: `ClickHeaderBtn_${id}` });
    }
    window.gtag("event", "ClickHeaderBtn", {
      transaction_id: `ClickHeaderBtn_${id}`,
    });
  },
  clickClosePreRegistrationPopupBtn(id) {
    if (!shouldFire("ClickClosePreRegistrationPopupBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickClosePreRegistrationPopupBtn", {}, { eventID: `ClickClosePreRegistrationPopupBtn_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickClosePreRegistrationPopupBtn", {}, { event_id: `ClickClosePreRegistrationPopupBtn_${id}` });
    }
    window.gtag("event", "ClickClosePreRegistrationPopupBtn", {
      transaction_id: `ClickClosePreRegistrationPopupBtn_${id}`,
    });
  },
  clickCloseLoginPopupBtn(id) {
    if (!shouldFire("ClickCloseLoginPopupBtn", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "ClickCloseLoginPopupBtn", {}, { eventID: `ClickCloseLoginPopupBtn_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("ClickCloseLoginPopupBtn", {}, { event_id: `ClickCloseLoginPopupBtn_${id}` });
    }
    window.gtag("event", "ClickCloseLoginPopupBtn", {
      transaction_id: `ClickCloseLoginPopupBtn_${id}`,
    });
  },
  LoginSuccess(id) {
    if (!shouldFire("LoginSuccess", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq("track", "LoginSuccess", {}, { eventID: `LoginSuccess_${id}` });
    }
    if (channel.indexOf("tt") !== -1) {
      window.ttq.track("LoginSuccess", {}, { event_id: `LoginSuccess_${id}` });
    }
    window.gtag("event", "LoginSuccess", {
      transaction_id: `LoginSuccess_${id}`,
    });
  },
  clickButton(id) {
    if (!shouldFire("ClickButton", id)) return;
    const channel = window.location.pathname;
    if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "track",
        "ClickButton",
        {},
        { eventID: `ClickButton_${id}` }
      );
    }
    if (channel.indexOf("tt") !== -1) {
      // window.ttq.track(
      //   "ClickButton",
      //   {},
      //   { event_id: `ClickButton_${id}` }
      // );
    }
    window.gtag("event", "ClickButton", {
      transaction_id: `ClickButton_${id}`,
    });
  },
  regist(id) {
    const channel = window.location.pathname;
    if (channel.indexOf("tt") !== -1) {
      // window.ttq.grantConsent();
      // const crypto = require("crypto");
      // const idHash = crypto.createHash("sha256");
      // idHash.update(String(id));
      // const idhex = idHash.digest("hex");
      // window.ttq.identify({
      //   external_id: idhex,
      // });
      window.ttq.track("ClickButton", {}, { event_id: id });
      // // trace.postEventTrack(id, "CompleteRegistration");
    } else if (channel.indexOf("fb") !== -1) {
      window.fbq(
        "track",
        "CompleteRegistration",
        {},
        { external_id: id, eventID: id }
      );
      // trace.postSubmitEvent(id, "CompleteRegistration");
    } else if (channel.indexOf("x") !== -1) {
      window.twq("event", "tw-onsgj-onsgo", {
        status: "completed",
        conversion_id: id,
        email_address: localStorage.getItem("email"),
      });
      window.twq("event", "tw-onu2d-onu2f", {
        status: "completed",
        conversion_id: id,
        email_address: localStorage.getItem("email"),
      });
    } else if (channel.indexOf("sc") !== -1) {
      window.snaptr("track", "SIGN_UP", {
        uuid_c1: id,
        user_email: localStorage.getItem("email"),
      });
    }
    window.gtag("event", "CompleteReg", {
      transaction_id: `CompleteReg_${id}`,
    });
    // window.fbq("track", "CompleteRegistration",{},{"external_id":id,'eventID':id});
    // window?._mtm?.push?.({event: 'login'})
  },
  getCookie(name) {
    const cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split("=");
      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return "";
  },
  transformUrl(url) {
    return url.replace(/\/([^/]+)\/([^/]*)\/*$/, (match, prefix, suffix) => {
      if (suffix === "") {
        // 如果没有额外的斜杠或文本，即匹配到了 /prefix/
        return prefix;
      } else {
        // 如果有额外的斜杠和文本，即匹配到了 /prefix/suffix/
        return `${prefix}-${suffix}`;
      }
    });
  },
  wishlist() {
    window.fbq("track", "AddToWishlist");
    // window.ttq.track('AddToWishlist', {})
  },
  shopcat() {
    window.fbq("track", "AddToCart");
    // window.ttq.track('AddToCart', { contents: [] })
    // window?._mtm?.push?.({event: 'gotoios'})
  },
  postSubmitEvent(id, event) {
    const fbp = this.getCookie("_fbp");
    const fbc = this.getCookie("_fbc");
    api.postSubmitEvent(event, fbp, id, fbc, id, window.location.href);
  },
  postEventTrack(id, event) {
    const ttclid = this.getCookie("ttclid");
    const ttp = this.getCookie("_ttp");
    api.postEventTrack(
      event,
      id,
      ttclid,
      store.getters.getEmail,
      id,
      ttp,
      window.location.href
    );
  },
};



// WEBPACK FOOTER //
// ./src/utils/index.js